export default function HeroSection() {
  return (
    <section id="hero" className="relative min-h-[600px] md:min-h-[700px] flex items-center pt-[72px] overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/80 via-background-50 to-accent-50/60"></div>
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary-100/30 rounded-full blur-3xl -translate-y-1/3 translate-x-1/4"></div>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-accent-100/30 rounded-full blur-3xl translate-y-1/3 -translate-x-1/4"></div>

      <div className="relative w-full px-4 md:px-6 py-12 md:py-20">
        <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/70 text-primary-700 text-sm font-medium mb-6">
              <i className="ri-fire-line text-base"></i>
              <span className="whitespace-nowrap">全网热门影视免费看</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-black text-foreground-950 font-heading leading-tight mb-4">
              91影视看片app
              <span className="block text-primary-600">高清免费在线看片追剧平台</span>
            </h1>

            <p className="text-lg md:text-xl text-foreground-600 font-medium mb-3 leading-relaxed">
              打开即看，不用缓冲，不花一分钱
            </p>

            <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              91影视看片app汇聚海量高清影视资源，涵盖热门电视剧、院线大片、综艺节目与动漫番剧。每日同步更新最新片源，智能匹配最优播放线路，让你在任何网络环境下都能流畅观影。无论你是追剧达人还是电影爱好者，这里都是属于你的免费追剧平台 —— 无需注册、无需付费、无需等待，打开即享极致观影体验。当前热播剧集与经典老片一应俱全，新用户首屏即可发现你想看的内容。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <div className="w-2 h-2 rounded-full bg-accent-500"></div>
                <span>片源<strong className="text-foreground-900">每日更新</strong></span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <div className="w-2 h-2 rounded-full bg-secondary-500"></div>
                <span>覆盖<strong className="text-foreground-900">全网热剧</strong></span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <div className="w-2 h-2 rounded-full bg-primary-500"></div>
                <span>承诺<strong className="text-foreground-900">完全免费</strong></span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                className="whitespace-nowrap w-full sm:w-auto px-8 py-3.5 rounded-lg bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors text-center cursor-pointer"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                <i className="ri-play-circle-line mr-2"></i>开始追剧
              </a>
              <a
                href="#app"
                className="whitespace-nowrap w-full sm:w-auto px-8 py-3.5 rounded-lg border-2 border-foreground-200 text-foreground-700 font-semibold text-sm hover:border-foreground-400 hover:text-foreground-900 transition-colors text-center cursor-pointer"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#app')?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                <i className="ri-smartphone-line mr-2"></i>下载APP
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-md lg:max-w-lg">
              <div className="relative rounded-2xl overflow-hidden bg-background-100 aspect-[4/5]">
                <img
                  src="https://readdy.ai/api/search-image?query=Cinematic%20film%20composition%20with%20warm%20golden%20lighting%2C%20abstract%20movie%20elements%20floating%2C%20dark%20theater%20curtain%20background%2C%20film%20reel%20motifs%2C%20soft%20dramatic%20shadows%2C%20premium%20streaming%20platform%20aesthetic%2C%20rich%20amber%20and%20coral%20tones%2C%20modern%20minimalist%20design%2C%20high%20contrast%20artistic%20photography%2C%20elegant%20composition&width=900&height=1125&seq=hero-visual-01&orientation=portrait"
                  alt="91影视看片app - 高清免费在线看片追剧平台"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/30 via-transparent to-transparent"></div>
              </div>
              <div className="absolute -bottom-4 -right-4 w-32 h-32 bg-accent-500/20 rounded-2xl -z-10"></div>
              <div className="absolute -top-4 -left-4 w-24 h-24 bg-primary-500/20 rounded-2xl -z-10"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}